<template>
  <b-modal
    id="create-emergency-drill-modal"
    title="EmergencyDrill Create Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Create Emergency Drill</h2>
    </template>
    <validation-observer ref="emergency_drillCreateFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">

        <b-form-group label-for="site">
          <template #label>
            Site <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="site"
            placeholder="Select Site"
            :options="sites"
            autoscroll
            :clearable="true"
            @input="fetchBuildings()"
            required
          ></v-select>
        </b-form-group>

        <b-form-group label-for="building">
          <template #label>
            Building <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="building"
            placeholder="Select Building"
            :options="buildings"
            autoscroll
            :clearable="true"
            required
          ></v-select>
        </b-form-group>

        <b-form-group label-for="title">
          <template #label>
            Title <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="title"
            v-model="title"
            placeholder="Title"
            required
          />
        </b-form-group>

        <b-form-group label-for="body">
          <template #label>
            Message <span class="text-danger">*</span>
          </template>
          <b-form-textarea
            id="body"
            v-model="body"
            placeholder="Message"
            required
          />
        </b-form-group>


        <!-- <b-form-group label-for="device">
          <template #label>
            Device <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="device"
            placeholder="Select Device"
            :options="devices"
            autoscroll
            :clearable="true"
            required
          ></v-select>
        </b-form-group> -->


        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
            :disabled="isSubmitting"
          >
            <b-spinner v-if="isSubmitting" small class="mr-1" />
              {{ isSubmitting ? 'Generating Emails ...' : 'Create' }}
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  mixins: [util],
  data() {
    return {
      required,
      regex: /^[a-zA-Z ]*$/,
      sites: [],
      site: "",
      buildings: [],
      building: "",
      title: '',
      body: '',
      isSubmitting: false,
    };
  },
  methods: {
    ...mapActions({
      createEmergencyDrill: "appData/createEmergencyDrill",
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
    }),

    async submit() {
      if (this.isSubmitting) return;

      try {
        this.isSubmitting = true;
        const formData = new FormData();
        
        formData.append("body", this.body);
        formData.append("title", this.title);
        formData.append("site", this.site.id);
        formData.append("building", this.building.id);
        formData.append("created_by", this.getLoggedInUser.id);
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.createEmergencyDrill(formData);
        if (res.status === 201) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Emergency Drill Created Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("create-emergency-drill-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    async fetchBuildings(){
      const buildings =  await this.getBuildingsDDL();
      this.buildings = buildings.data;

      // const devices =  await this.getDevicesDDL();
      // this.devices = devices.data;

      this.building = "";
      // this.device = "";
       if (!this.site) {
        this.buildings = [];
        // this.devices = [];
        return;
      }
      this.buildings = this.buildings.filter(building => building.site === this.site.id);      
    },


    reset() {
      this.name = "";
      this.site = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
  async mounted(){
    const sites =  await this.getSitesDDL();
    this.sites = sites.data;
  },
};
</script>

<style></style>
